import { RouteConfig } from "vue-router";

import { Network } from "@/network";

const InfoRoute: Array<RouteConfig> = [
  {
    path: "/info/mood_board",
    component: () => import("@/views/ap/info/Index.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/info/mood_board/tmp/favorite",
    component: () => import("@/views/ap/info/TmpFavorite.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/info/mood_board/material",
    name: "moodBoardMaterial",
    component: () => import("@/views/ap/info/MoodBoardSelected.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    },
    props: true
  },
  {
    path: "/account",
    name: "Account",
    component: () => import("@/views/ap/account/Account.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/info/palette",
    component: () => import("@/views/ap/info/Palette.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/info/palette/cont",
    component: () => import("@/views/ap/info/PaletteCont.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },

  //20230616 以下新增
  {
    path: "/info/design",
    component: () => import("@/views/ap/info/Design.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },
  {
    path: "/info/design/cont",
    component: () => import("@/views/ap/info/DesignCont.vue"),
    beforeEnter: (to, from, next) => {
      if (Network.authCheck()) {
        next();
      } else {
        next("/login");
      }
    }
  },

];

export { InfoRoute };
